import { type ReactElement } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { MobileLogin } from "./Login/MobileLogin";
import { MobileVerify } from "./Login/MobileVerify";
import { MobileLoginWithEmailAndPassword } from "./LoginWithEmailAndPassword/MobileLoginWithEmailAndPassword";
import { MobileApp } from "./MobileApp";

/**
 * Mobile routes structure:
 * - /mobile/login - Unauthenticated login (no bottom nav)
 * - /mobile/login/verify - Email verification (opened from email link)
 * - /mobile/* - Authenticated routes (with bottom nav via MobileApp)
 *
 * Session initialization (Cognito + Firebase fallback) is handled by AppLayout,
 * which renders MobileRoutes when the path starts with /mobile.
 */
export function MobileRoutes(): ReactElement {
  return (
    <Switch>
      {/* Email verification (opened from email link in browser) */}
      <Route exact path="/mobile/login/verify">
        <MobileVerify />
      </Route>

      {/* Unauthenticated: Login page without bottom nav */}
      <Route exact path="/mobile/login">
        <MobileLogin />
      </Route>

      {/* Unauthenticated: Email and password login */}
      <Route exact path="/mobile/login/password">
        <MobileLoginWithEmailAndPassword />
      </Route>

      {/* Default redirect */}
      <Route exact path="/mobile">
        <Redirect to="/mobile/profile" />
      </Route>

      {/* Authenticated routes with bottom nav */}
      <Route path="/mobile">
        <MobileApp />
      </Route>
    </Switch>
  );
}
